import { Controller } from "@hotwired/stimulus"

// Handles chat input form: submit, enter-to-send, loading state, suggested prompts.
export default class extends Controller {
  static targets = ["form", "input", "submitButton", "spinner", "icon"]

  // Called from the form's submit event — show loading UI then let the form submit
  submit(event) {
    const content = this.inputTarget.value.trim()
    if (!content) {
      event.preventDefault()
      return
    }

    this.showLoading()
    document.dispatchEvent(new CustomEvent("chat:message-submitted"))
  }

  submitSuggested(event) {
    const suggestion = event.currentTarget.dataset.suggestion
    if (!suggestion) return

    this.inputTarget.value = suggestion
    this.showLoading()
    document.dispatchEvent(new CustomEvent("chat:message-submitted"))
    this.formTarget.requestSubmit()
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      const content = this.inputTarget.value.trim()
      if (!content) return

      this.showLoading()
      document.dispatchEvent(new CustomEvent("chat:message-submitted"))
      this.formTarget.requestSubmit()
    }
  }

  autoResize() {
    const el = this.inputTarget
    el.style.height = "auto"
    el.style.height = Math.min(el.scrollHeight, 160) + "px"
  }

  showLoading() {
    this.submitButtonTarget.disabled = true
    this.inputTarget.readOnly = true
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    if (this.hasIconTarget) this.iconTarget.classList.add("hidden")
  }

  hideLoading() {
    this.submitButtonTarget.disabled = false
    this.inputTarget.readOnly = false
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    if (this.hasIconTarget) this.iconTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  reset() {
    this.hideLoading()
    this.inputTarget.value = ""
  }
}
